import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DistributeColumns = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          d="M14 2.5a.5.5 0 0 0-1 0v1H8.5v-1a.5.5 0 0 0-1 0v1H3v-1a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-1h4.5v1a.5.5 0 0 0 1 0v-1H13v1a.5.5 0 0 0 1 0v-3ZM3 8h4.5v5H3V8Zm5.5 5V8H13v5H8.5ZM2 8c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1H3a1 1 0 0 1-1-1V8Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DistributeColumns
